<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative">
      <h3 class="font-medium">{{ title }}</h3>

      <p class="text-sm mt-2 text-content-400">{{ message }}</p>

      <form v-if="mode === 'shipped'" @submit.prevent="confirm" class="mt-4">
        <div class="flex flex-col w-full">
          <label for="tracking_number"># de guía</label>
          <input
            id="tracking_number"
            type="text"
            v-model="form.tracking_number"
            required
          />
          <validation-errors :errors="errorFor('tracking_number')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-2">
          <label for="tracking_url">URL de rastreo (opcional)</label>
          <input
            id="tracking_url"
            type="url"
            v-model="form.tracking_url"
            placeholder="https://..."
          />
          <validation-errors :errors="errorFor('tracking_url')"></validation-errors>
        </div>

        <primary-button class="w-auto mt-4" :loading="loading" type="submit">
          Marcar como enviada
        </primary-button>

        <button v-if="!loading" class="link mt-4 mx-auto w-full" @click.prevent="close">
          Cancelar
        </button>
      </form>

      <div v-else>
        <primary-button class="w-auto mt-4" :loading="loading" @buttonClicked="confirm">
          Confirmar
        </primary-button>
        <button v-if="!loading" class="link mt-4 mx-auto w-full" @click.prevent="close">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import validationErrors from "@/mixins/validationErrors";
export default {
  name: "Shop Order Transition Modal",

  mixins: [validationErrors],

  props: {
    mode: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        tracking_number: "",
        tracking_url: "",
      },
    };
  },

  computed: {
    title() {
      switch (this.mode) {
        case "shipped":
          return "Marcar como enviada";
        case "cancelled":
          return "Cancelar pedido";
        case "refunded":
          return "Reembolsar pedido";
        case "packing":
          return "Marcar como empacada";
        case "delivered":
          return "Marcar como entregada";
        default:
          return "Confirmar acción";
      }
    },

    message() {
      switch (this.mode) {
        case "cancelled":
          return "¿Seguro que deseas cancelar este pedido? Se restaurará el inventario.";
        case "refunded":
          return "¿Seguro que deseas reembolsar este pedido? Esta acción llamará a Stripe y no se puede deshacer.";
        case "packing":
          return "¿Marcar este pedido como empacado?";
        case "delivered":
          return "¿Marcar este pedido como entregado?";
        case "shipped":
          return "Captura el número de guía y URL de rastreo (opcional).";
        default:
          return "";
      }
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },

    confirm() {
      if (this.mode === "shipped") {
        this.errors = {};
        if (!this.form.tracking_number) {
          this.errors["tracking_number"] = ["Campo requerido"];
          return;
        }
        this.$emit("confirm", {
          tracking_number: this.form.tracking_number,
          tracking_url: this.form.tracking_url || null,
        });
        return;
      }
      this.$emit("confirm");
    },
  },
};
</script>
